"use client";

import { LoginForm } from "../components/login-form";
import { useTranslations } from "next-intl";

export function LoginViewPage() {
  const title = useTranslations("Title.Login");

  return (
    <section className="auth__stack-center auth__login-view">
      <h1 className="auth__title-primary">
        {title("title")}
      </h1>
      <LoginForm />
    </section>
  );
}
